module.exports = __webpack_public_path__ + "media/images/icons/monitoringZivotnihoProstrediW-5c9e8b5b6c95b422f8df208c305bf09c.svg";